import { render, staticRenderFns } from "./feedbackEntrance.vue?vue&type=template&id=372a0925&scoped=true"
import script from "./feedbackEntrance.vue?vue&type=script&lang=ts"
export * from "./feedbackEntrance.vue?vue&type=script&lang=ts"
import style0 from "./feedbackEntrance.vue?vue&type=style&index=0&id=372a0925&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372a0925",
  null
  
)

export default component.exports